module.exports = __webpack_public_path__ + "img/dajian_bg.b34a84f8.png";